import { render, staticRenderFns } from "./iosform.vue?vue&type=template&id=29bf0228&"
import script from "./iosform.vue?vue&type=script&lang=ts&"
export * from "./iosform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports